import { Component, Input, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { AppConstants } from 'src/app/app.constants';
import { Subject } from 'rxjs';
import { UserRepositoryService } from '../../../services/user-repository.service';
import { NewsUpdateDetailsService } from 'src/app/services/news-update-details.service';
import { DownloadFileService } from 'src/app/services/download-file.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { AdminRepositoryService } from 'src/app/services/admin-repository.service';

@Component({
  selector: 'app-solar-annoucements',
  templateUrl: './solar-annoucements.component.html',
  styleUrls: ['./solar-annoucements.component.scss']
})
export class SolarAnnoucementsComponent implements OnInit {
  panelOpenState = false;
  expandPanel: number;
  hrefLinks = AppConstants;
  private unsubscribe: Subject<void> = new Subject<void>();
  pageContents: any;
  pageContentsDetails: any;

  constructor(
    private newsUpdateService: NewsUpdateDetailsService,
    private userRepository: UserRepositoryService,
    private downloadFileService: DownloadFileService,
    private snackBarService: SnackBarService,
    private adminRepositoryService: AdminRepositoryService,
    private dialogRef: MatDialogRef<SolarAnnoucementsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.expandPanel = this.data.panelState;
    this.getHomePageContents();
    this.pageContentsDetails = this.data.pageContents;
  }

  onOkClick() {
    this.dialogRef.close(null);
  }

  onCloseClick() {
    this.dialogRef.close(null);
  }

  getHomePageContents() {
    this.userRepository.getHomePageContents()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((homePageContents) => {
        if (homePageContents) {
          this.pageContents = homePageContents;
        }
      });
  }

  downloadDocument(documentName: string, action: string, linkType: string) {//rowData){
    const logHeader = {
      documentName: documentName.split(".")[0],
      action: action,
      extension: "." + documentName.split('.').pop() || '', // "." + documentName.split(".")[1]
      formName: documentName.split(".")[0]
    };

    if (linkType === 'Document') {
      this.adminRepositoryService
        .getHomeSectionFile(documentName)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (solarFormDownloadData: any) => {
            this.downloadFileService.previewSolarForm(solarFormDownloadData, logHeader);
          },
          (err) => {
            // this.snackBService.showError(err);
          }
        );
    }
  }
}
